import React, { useState } from 'react';
import './index.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Story from './components/Story';
import Brews from './components/Brews';
import Kitchen from './components/Kitchen';
import Experience from './components/Experience';
import Events from './components/Events';
import Reserve from './components/Reserve';
import Footer from './components/Footer';
import MenuPage from './components/MenuPage';

export default function App() {
  const [page, setPage] = useState('home');

  const handleNavigate = (target, hash) => {
    setPage(target);

    if (target === 'home') {
      window.setTimeout(() => {
        const el = hash ? document.querySelector(hash) : null;
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }, 80);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div style={{ background: '#050505', overflowX: 'hidden' }}>
      <Navbar currentPage={page} onNavigate={handleNavigate} />
      {page === 'menu' ? (
        <MenuPage />
      ) : (
        <>
          <Hero />
          <Story />
          <Brews />
          <Kitchen />
          <Experience />
          <Events />
          <Reserve />
        </>
      )}
      <Footer />
    </div>
  );
}
